// @generated-imports
import { escapeHTML } from './app.js';
import { CONFIG, dom } from './core.js';
import { layerClosed, layerOpened } from './layers.js';
import { getSetting, isTouchDevice } from './platform.js';
// @generated-imports
/* ===========================================================================
   ESCALA DA INTERFACE e "O QUE HÁ DE NOVO" (v2.1)
   ======================================================================== */

/** O CSS usa rem: escalar o font-size da raiz amplia texto, botões e cards. */
function resolveUiScale() {
  const setting = String(getSetting('uiScale') || 'auto');
  if (setting !== 'auto') return Number(setting) || 100;
  const wide = Math.max(window.innerWidth || 0, (window.screen && window.screen.width) || 0) >= 1600;
  let pad = false;
  try { pad = navigator.getGamepads ? [...navigator.getGamepads()].some(Boolean) : false; } catch (_) {}
  return wide && pad && !isTouchDevice() ? 115 : 100;
}

function applyUiScale() {
  const scale = resolveUiScale();
  document.documentElement.style.fontSize = scale === 100 ? '' : `${scale}%`;
  document.documentElement.dataset.uiScale = String(scale);
  return scale;
}

function initUiScale() {
  applyUiScale();
  window.addEventListener('gamepadconnected', applyUiScale);
  window.addEventListener('gamepaddisconnected', applyUiScale);
  window.addEventListener('resize', () => { if (String(getSetting('uiScale')) === 'auto') applyUiScale(); });
}

/* --- Novidades ----------------------------------------------------------- */

const WHATS_NEW = {
  version: '2.1.0',
  title: 'Novidades da 2.1 — na TV, sem tocar no mouse',
  items: [
    ['☰ Menu de pausa', 'Toque Select+Start (ou o botão Home) durante o jogo: salvar, carregar, voltar no tempo, avanço rápido e trocar jogadores, tudo pelo controle.'],
    ['⏱ Salvar automático', 'O progresso é gravado a cada 5 minutos. Se a TV box reiniciar, o EmuTab oferece retomar de onde parou.'],
    ['⏪ Voltar no tempo', 'Errou o pulo? No menu de pausa, volte 10, 30 ou 60 segundos.'],
    ['👤 Perfis', 'Cada pessoa com seus favoritos, recentes, estados e conquistas.'],
    ['✈️ Offline por jogo', 'Marque um jogo como disponível offline no detalhe dele.'],
    ['📊 Estatísticas e 🏆 conquistas', 'Seu tempo de jogo por sistema, os mais jogados e marcos desbloqueados.'],
    ['📚 Coleções e ⏳ Jogar depois', 'Monte listas próprias e filtre o catálogo por elas.'],
  ],
};

function isReturningUser() {
  const keys = [CONFIG.localStorageRecentKey, CONFIG.localStoragePlayTimeKey, CONFIG.localStorageFavoritesKey, CONFIG.localStorageLastGameKey];
  return keys.some((key) => localStorage.getItem(key) !== null);
}

/** Mostra as novidades uma vez por versão para quem já usava o EmuTab. */
function maybeShowWhatsNew() {
  const seen = localStorage.getItem(CONFIG.localStorageSeenVersionKey);
  const current = WHATS_NEW.version;
  try { localStorage.setItem(CONFIG.localStorageSeenVersionKey, current); } catch (_) {}
  if (seen === current) return false;
  if (!seen && !isReturningUser()) return false; // primeira visita: nada a comparar
  openWhatsNew();
  return true;
}

function openWhatsNew() {
  if (!dom.whatsNewModal) return;
  dom.whatsNewTitle.textContent = `✨ ${WHATS_NEW.title}`;
  dom.whatsNewList.innerHTML = WHATS_NEW.items.map(([title, text]) => `<div class="backup-row">
      <strong>${escapeHTML(title)}</strong> — ${escapeHTML(text)}
    </div>`).join('');
  dom.whatsNewModal.classList.remove('is-hidden');
  layerOpened('whats-new', dom.whatsNewClose);
}

function closeWhatsNew() {
  if (!dom.whatsNewModal) return;
  dom.whatsNewModal.classList.add('is-hidden');
  layerClosed('whats-new');
}

// @generated-exports
export { WHATS_NEW, applyUiScale, closeWhatsNew, initUiScale, isReturningUser, maybeShowWhatsNew, openWhatsNew, resolveUiScale };
// @generated-exports
